'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, '__esModule', {
  value: true
});
var reactCookies = require('react-cookies');
var jwtDecode = require('jwt-decode');
function _interopDefaultLegacy(e) {
  return e && _typeof(e) === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var reactCookies__default = /*#__PURE__*/_interopDefaultLegacy(reactCookies);
var jwtDecode__default = /*#__PURE__*/_interopDefaultLegacy(jwtDecode);
var COOKIE_NAME = '5AJWT_AUTH';
var AUTH_MODE = 'auth_mode';

/**
 * This code was taken from block-party. Be careful before
 * copying/using it as it may contain old patterns/legacy code.
 *
 * Consider refactoring it if possible! :) For more info, check:
 * https://github.com/quintoandar/architecture-decisions/pull/125
 */
function hasAuthCookie() {
  return document && document.cookie && document.cookie.indexOf(COOKIE_NAME) >= 0;
}

/**
 * This code was taken from block-party. Be careful before
 * copying/using it as it may contain old patterns/legacy code.
 *
 * Consider refactoring it if possible! :) For more info, check:
 * https://github.com/quintoandar/architecture-decisions/pull/125
 */
function parseAuthMode() {
  return reactCookies__default['default'].load(AUTH_MODE);
}

/**
 * This code was taken from block-party. Be careful before
 * copying/using it as it may contain old patterns/legacy code.
 *
 * Consider refactoring it if possible! :) For more info, check:
 * https://github.com/quintoandar/architecture-decisions/pull/125
 */
function clearCookie(name, domain) {
  document.cookie = "".concat(name, "=;expires=Thu,01-Jan-70 00:00:01 GMT;domain=").concat(domain, ";path=/");
}
function clearListCookies(domain) {
  var cookies = document.cookie.split('; ');
  cookies.forEach(function (cookie) {
    clearCookie(cookie.split('=')[0], domain);
  });
}

/**
 * This code was taken from block-party. Be careful before
 * copying/using it as it may contain old patterns/legacy code.
 *
 * Consider refactoring it if possible! :) For more info, check:
 * https://github.com/quintoandar/architecture-decisions/pull/125
 */
function extractDomainName(hostname) {
  var host = hostname;
  host = host.replace(/^www\./i, '');
  return host;
}
function getCookieDomain() {
  var hostname = process.env.COOKIE_DOMAIN || window.location.hostname;
  var domainName = extractDomainName(hostname);
  return ".".concat(domainName);
}

/**
 * This code was taken from block-party. Be careful before
 * copying/using it as it may contain old patterns/legacy code.
 *
 * Consider refactoring it if possible! :) For more info, check:
 * https://github.com/quintoandar/architecture-decisions/pull/125
 */
function parseCookiesToUser() {
  var cookie = reactCookies__default['default'].load(COOKIE_NAME);
  var user = null;
  if (cookie) {
    try {
      user = jwtDecode__default['default'](cookie);
    } catch (error) {
      user = null;
    }
  }
  return user;
}
exports.clearListCookies = clearListCookies;
exports.extractDomainName = extractDomainName;
exports.getCookieDomain = getCookieDomain;
exports.hasAuthCookie = hasAuthCookie;
exports.parseAuthMode = parseAuthMode;
exports.parseCookiesToUser = parseCookiesToUser;
